<template>
  <div>
    <nav-title :title="'Child Profile'" :color="false" />

    <section class="container align-items-center pb-4">
      <div
        class="col-sm-12 col-12 d-flex align-items-center justify-content-end flex-column-reverse flex-sm-row"
      >
        <b-form-checkbox class="pr-2" switch size="lg" v-model="childEnable" id="enableChild">
          <label class="m-0 small" for="enableChild">
            Child
            <span v-if="childEnable">active</span>
            <span v-else>inactive</span>
          </label>
        </b-form-checkbox>
        |
        <b-link
          style="width: fit-content;"
          class="text-danger pl-2"
          block
          @click="() => deleteChild()"
          v-if="isEditMode"
        >
          Delete child
        </b-link>
      </div>

      <b-form onsubmit="return false;">
        <div class="form row align-items-center flex-column-reverse flex-md-row mt-3">
          <b-row class="mb-2 inputs-container col-md-7 col-12">
            <b-col cols="12" class="input-upper">
              <b-form-input type="text" maxlength="20" v-model="childName" required></b-form-input>
              <label class="small-icon">
                Child First Name
              </label>
            </b-col>
            <b-col cols="12" class="input-upper mt-4">
              <b-form-input type="text" v-model="childLastName" required></b-form-input>
              <label class="small-icon">
                Child Last Name
              </label>
            </b-col>
            <b-col cols="12" sm="12" class="input-date">
              <label class="small-icon label-date">
                Date of birth
              </label>
              <b-form-datepicker required v-model="childAge"></b-form-datepicker>
            </b-col>
            <b-col cols="12" sm="12" class="input-date" v-if="childId != null">
              <label class="small-icon label-date">
                Time Zone
              </label>
              <b-form-select
                class="flex-grow-1 flex-sm-grow-0"
                size="sm"
                v-model="selectedZone"
                :options="getTimeZoneList"
              >
              </b-form-select>
            </b-col>
          </b-row>

          <div class="justify-content-center text-center col-12 col-sm-5 mb-4 mb-sm-0">
            <div class="m-auto">
              <b-img
                v-if="!childAvatar"
                fluid
                width="220px"
                class="shadow rounded-25"
                :src="require(`@/assets/child-profile-empty.png`)"
              ></b-img>
              <b-img
                v-else
                width="220px"
                height="220px"
                class="fit-cover shadow rounded-25"
                :src="childAvatar"
              ></b-img>
            </div>
            <div class="mt-4">
              <b-link @click="modalAvantars = true" class="b-link">
                Change
              </b-link>
            </div>
          </div>
        </div>

        <b-modal v-model="modalAvantars" ref="modal" hide-header hide-footer centered size="lg">
          <b-form-group>
            <b-form-radio-group
              v-for="item in getAvatarImages"
              :key="item.id"
              v-model="selectedImage"
              name="radio-sub-images"
              class="radio-sub-images"
              @change="childAvatar = item.image"
            >
              <b-form-radio
                :value="item.id"
                :id="item.id.toString()"
                class="m-auto h-100"
                @change="modalAvantars = false"
              >
                <i class="material-icons check-icon">check_circle</i>
                <b-img
                  :style="selectedImage == item.id ? 'border: green 2px solid;' : ''"
                  :src="item.image"
                  class="avatar-img fit-cover3 shadow rounded-25"
                ></b-img>
              </b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-modal>

        <b-modal
          v-model="showDeleteWarning"
          ref="modalWarning"
          hide-header
          hide-footer
          centered
          size="lg"
        >
          <div class="d-flex w-100">
            <button
              type="button"
              class="modal-button-close border border-white bg-white ml-auto h4"
              @click="showDeleteWarning = false"
            >
              ×
            </button>
          </div>
          <div class="d-flex w-100 justify-content-center">
            You are about to eliminate this child.
          </div>
          <div class="d-flex w-100">
            <b-button
              type="button"
              variant="danger"
              class="mt-4"
              block
              @click="() => confirmDeleteChild()"
            >
              Yes, Delete
            </b-button>
          </div>
        </b-modal>

        <small v-if="error" class="text-danger d-block pb-1">
          {{ errorMessage }}
        </small>

        <b-button
          type="submit"
          variant="warning"
          class="mt-4"
          block
          :disabled="Empty"
          @click="sendData(true)"
        >
          Save
        </b-button>
        <b-button
          v-if="childId == null"
          type="submit"
          @click="sendData(false)"
          variant="warning"
          class="mt-2 mb-4"
          block
          :disabled="Empty"
        >
          Save and add another
        </b-button>
      </b-form>
    </section>
  </div>
</template>

<script>
import navTitle from '@/components/general/navTitle.vue';
import { mapActions, mapGetters } from 'vuex';
import store from '@/store';
export default {
  props: {
    heading: Boolean,
  },
  data() {
    return {
      childName: null,
      childLastName: null,
      childAge: null,
      childEmail: null,
      childPass: null,
      childRepass: null,
      childEnable: true,
      showButtonPass: null,
      showButtonRepass: null,
      emptyModules: null,
      requestSent: false,
      showError: false,
      childId: null,
      selectedZone: this.getTimeZone,
      childAvatar: '',
      modalAvantars: null,
      selectedImage: null,
      childrenOrder: [],
      userId: 0,
      isEditMode: false,
      showDeleteWarning: false,
    };
  },
  components: {
    navTitle,
  },
  watch: {
    selectedZone(newValue) {
      if (this.getTimeZone != newValue) {
        let zone = parseFloat(newValue).toFixed(2);
        let userId = this.$route.params.childId;
        if (userId) {
          this.setTimeZone({
            userIsAparent: false,
            userId: userId,
            time_zone: zone,
          });
        }
      }
    },
    getTimeZone(newValue) {
      this.selectedZone = newValue;
    },
  },
  created() {
    this.selectedZone = this.getTimeZone;
  },
  methods: {
    ...mapActions('user', ['registerChild', 'setTimeZone', 'deleteChildInfo']),
    ...mapActions('user', ['updateChildInfo', 'setChildAvatar']),
    ...mapActions('parent', [
      'setParentChildrenEnable',
      'setParentChildrenDisable',
      'getParentChildrenOrder',
    ]),
    selectChildAvatar(id, reload = true, then = () => {}) {
      this.setChildAvatar({
        childId: id || this.childId,
        idAvatar: this.selectedImage,
      }).then(() => {
        this.selectedImage = '';
        then();
        if (reload) {
          this.$router.go(0);
        }
      });
    },
    deleteChild() {
      this.showDeleteWarning = true;
    },
    confirmDeleteChild() {
      this.deleteChildInfo(this.childId).then(() => {
        this.$router.push({ name: 'Home' });
      });
    },
    showPass() {
      var tipo = document.getElementById('childPass');
      if (tipo.type == 'password') {
        tipo.type = 'text';
        this.showButtonPass = true;
      } else {
        tipo.type = 'password';
        this.showButtonPass = false;
      }
    },
    showRepass() {
      var tipo = document.getElementById('childRepass');
      if (tipo.type == 'password') {
        tipo.type = 'text';
        this.showButtonRepass = true;
      } else {
        tipo.type = 'password';
        this.showButtonRepass = false;
      }
    },
    async enableChild(childId) {
      if (this.childEnable) {
        await this.setParentChildrenEnable(childId);
      } else {
        await this.setParentChildrenDisable(childId);
      }
    },
    sendData(other) {
      if (this.childId != null) {
        const ChildId = this.childId;
        this.showError = false;
        this.updateChildInfo({
          childId: this.childId,
          name: this.childName,
          last_name: this.childLastName,
          birthdate: this.childAge,
        }).then(() => {
          const enableChildPromise = this.enableChild(ChildId);
          let sendChildAvatarPromise = () => {};
          if (this.selectedImage) {
            sendChildAvatarPromise = this.selectChildAvatar(ChildId, false, () => {
              console.log('call then');
              this.$router.push({ name: 'Home' });
            });
          }

          Promise.all([enableChildPromise, sendChildAvatarPromise]).then(() => {
            this.$router.push({ name: 'Home' });
          });
        });
      } else {
        this.showError = false;
        this.registerChild({
          name: this.childName,
          last_name: this.childLastName,
          birthdate: this.childAge,
          parent: this.getUserId,
        }).then((response) => {
          if (response) {
            const ChildId = response;
            if (!other) {
              this.childName = null;
              this.childLastName = null;
              this.childAge = null;
            } else {
              const localChildrenOrder = this.childrenOrder;
              const enableChildPromise = this.enableChild(ChildId);
              const updatedChildrenOrder = [ChildId, ...localChildrenOrder];
              const childrenOrderPromise = store.dispatch('parent/setParentChildrenOrder', {
                userId: this.userId,
                childrenOrder: updatedChildrenOrder,
              });
              let sendChildAvatarPromise = () => {};
              if (this.selectedImage) {
                sendChildAvatarPromise = this.selectChildAvatar(ChildId, false, () =>
                  this.$router.push({ name: 'Home' }),
                );
              }
              Promise.all([enableChildPromise, sendChildAvatarPromise, childrenOrderPromise]).then(
                () => {
                  this.$router.push({ name: 'Home' });
                },
              );
            }
          } else {
            this.showError = true;
          }
        });
      }
    },
  },
  computed: {
    ...mapGetters('parent', ['getChildrenOrder', 'getChildrenData']),
    ...mapGetters('user', [
      'getChildInfo',
      'error',
      'errorMessage',
      'getTimeZoneList',
      'getTimeZone',
      'getUserId',
      'getChildAvatar',
    ]),
    ...mapGetters('general', ['getAvatarImages']),
    Empty() {
      if (this.childName == null) return true;
      if (this.childLastName == null) return true;
      if (this.childAge == null) return true;
      if (this.childId != null) return false;
      return false;
    },
  },
  beforeMount() {
    if (this.$route.params.childId) {
      let childExtraData = sessionStorage.getItem('clickedChild');
      childExtraData = childExtraData ? JSON.parse(childExtraData) : null;
      if (childExtraData && this.$route.params.childId == childExtraData.id) {
        if (childExtraData) {
          this.childEnable = childExtraData.enable;
        } else {
          this.childEnable = true;
        }
      } else {
        return (window.location.href = `${window.location.protocol + '/' + '/'}${
          window.location.host
        }/update-select-child?next=register-child`);
      }
    }
  },
  mounted() {
    this.userId = store.getters['user/getUserId'];
    if (this.$route.params.childId) {
      // fill child inputs information
      this.childId = this.$route.params.childId;
      // load avatar data
      this.childAvatar = this.childId ? this.getChildAvatar.image : '';
      this.selectedImage = this.getChildAvatar.id;

      // show delete button if original parent is logged
      if (this.getChildInfo(this.childId).parent == this.userId) {
        this.isEditMode = true;
      }
      this.childName = this.getChildInfo(this.childId).name;
      //this.childEmail = this.getChildInfo(this.childId).user.username;
      this.childLastName = this.getChildInfo(this.childId).last_name;
      this.childAge = this.getChildInfo(this.childId).birthdate;
    } else {
      // clear avatar data
      this.childAvatar = '';
      this.selectedImage = 0;

      // get children order from database and store it on local state
      this.getParentChildrenOrder(this.userId).then(() => {
        // TODO: as function if posible**********************************************************************
        let childrenData = this.getChildrenData;
        let orderedChilds = [];
        let extraChilds = [];
        let childrenOrder = this.getChildrenOrder;
        if (childrenOrder) {
          // get ordered sublist  using parent preferences
          orderedChilds = childrenOrder.map((childId) => {
            return childrenData.filter((c) => c.id == childId)[0];
          });
          // get excedent sublist
          extraChilds = childrenData.filter((childId) => !childrenOrder.includes(childId.id));
          childrenData = [...extraChilds, ...orderedChilds];
        }

        this.childrenOrder = childrenData.map((child) => {
          return child ? child.id : null;
        });
        //**********************************************************************
      });
    }
  },
  beforeRouteEnter(to, from, next) {
    const userId = store.getters['user/getUserId'];
    let userIsAParent = store.getters['user/userIsAParent'];
    let data = { userIsAparent: userIsAParent, userId: userId };
    Promise.all([store.dispatch('general/fetchAvatarImages', data)]).then(() => {
      if (to.params.childId) {
        Promise.all([
          store.dispatch('user/fetchChildInfo', to.params.childId),
          store.dispatch('user/fetchTimeZone'),
          store.dispatch('user/GetTimeZone', { userIsAparent: false, userId: to.params.childId }),
          store.dispatch('user/fetchChildAvatar', to.params.childId),
        ]).then(() => {
          next();
        });
      } else {
        next();
      }
    });
  },
};
</script>

<style scoped>
input[type='radio']:checked + label i {
  font-size: 32px;
  display: block;
}
input[type='radio']:checked + label {
  color: var(--aside003);
}

.radio-sub-images .check-icon {
  position: absolute;
  float: left;
  z-index: 1000;
}
.radio-sub-images .custom-control {
  margin: 0;
  padding: 0;
}
.enable-child-checkbox .enable-child-checkbox-input {
  width: 1rem;
  height: 1rem;
}
</style>
<style lang="scss">
.form-group {
  .bv-no-focus-ring {
    display: flex;
    flex-wrap: wrap;
    .radio-sub-images {
      flex: 0 0 25%;
      max-width: 25%;
      padding: 2px;
    }
  }
}

.avatar-img {
  min-height: 100px;
  height: 150px;
  max-height: 150px;
  object-fit: cover;
  min-width: 150px;
  width: 150px;
  max-width: 150px;
  cursor: pointer;
}

.avatar-img:hover {
  border: blue 2px solid;
}

.rounded-25 {
  border-radius: 10px;
}

.fit-cover {
  object-fit: cover;
}

@media (max-width: 992px) {
  .form-group {
    .bv-no-focus-ring {
      .radio-sub-images {
        flex: 0 0 33.3333%;
        max-width: 33.3333%;
      }
    }
  }
}

@media (max-width: 575px) {
  .form-group {
    .bv-no-focus-ring {
      .radio-sub-images {
        flex: 0 0 50%;
        max-width: 50%;
      }
    }
  }
}
input[type='radio'] + label i {
  display: none;
}
.custom-radio .custom-control-label::before {
  display: none;
}

.radio-sub-images {
  .custom-control-label::after {
    display: none;
  }
}
</style>
